import { useSelector } from "react-redux";
import { getLocaleString } from "./selectors";

export const useLocalizationString = () =>
  useSelector((state) => getLocaleString(state));
